import { IconButton, InputAdornment, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { RHFTextField } from "src/components/hook-form";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

export default function PasswordInput() {
	const [showPassword, setShowPassword] = useState(false);

	const { translate } = useLocales();

	return (
		<Stack gap={0.5}>
			<Typography variant='subtitle1' fontSize={15}>
				{translate("app_secrets.confirm_password")}
			</Typography>
			<Typography variant='subtitle1' fontSize={12} color='text.secondary'>
				{translate("app_secrets.crate_secret_des")}
			</Typography>
			<RHFTextField
				fullWidth
				InputProps={{
					endAdornment: (
						<InputAdornment position='end'>
							<IconButton edge='end' onClick={() => setShowPassword(!showPassword)}>
								<Iconify icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"} />
							</IconButton>
						</InputAdornment>
					)
				}}
				label={translate("app_secrets.add_password")}
				margin='dense'
				name='password'
				type={showPassword ? "text" : "password"}
			/>
		</Stack>
	);
}
